export function showAlert(alertInfo: any) {
  const Toast = alertInfo.vm.$swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: alertInfo.timer || 2500,
    timerProgressBar: true,
  });
  Toast.fire({
    icon: alertInfo.icon,
    title: alertInfo.title,
  });
}

export function confirmModal(alertInfo: any) {
  return alertInfo.vm.$swal({
    title: alertInfo.title,
    text: alertInfo.text,
    icon: alertInfo.icon,
    background: "#ececec",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
    showCancelButton: alertInfo.showCancelButton,
    confirmButtonText: alertInfo.confirmButtonText || "Si",
    cancelButtonText: alertInfo.cancelButtonText || "No",
    showCloseButton: alertInfo.showCloseButton,

  })
}